export const marketingTypes: string[] = [
  'MarketingProfileCreate',
  'MarketingProfileUpdate',
  'IncludeMarketingProfile',
  'ExcludeMarketingProfile',
  'AssignMarketingProfile',
  'MarketingCommentCreate',
  'MarketingCommentUpdate',
  'MarketingCommentDelete',
  'DeleteMarketingProfile'
];

export const membersTypes: string[] = ['MemberCreate', 'MemberUpdate'];
export const rolesTypes: string[] = ['RoleCreate', 'RoleUpdate'];

export const profileActivityWithOrganization: string[] = [
  'ExcludeMarketingProfile',
  'IncludeMarketingProfile',
  'AssignMarketingProfile'
];

export const userTypes: string[] = [
  'UserRoleUpdate',
  'UserCreate',
  'UserUpdate',
  'UserPasswordReset',
  'UserForgotPasswordRequest'
];

export const systemActivityTypesTableConfigs: Record<string, string> = {
  [marketingTypes.join(' ')]: 'marketing',
  [membersTypes.join(' ')]: 'members',
  [rolesTypes.join(' ')]: 'roles',
  [userTypes.join(' ')]: 'affectedUser',
  Logout: 'isForcedLogout',
  default: 'empty'
};
